export default __webpack_public_path__ + "static/transportation-accomplishment-2-2e3dbe12b570a7250154a2595c5078da.webp";